import VueDrapTimepicker from './vue-drap-timepicker.vue';

module.exports = {
	install: Vue => {
		Vue.component('vue-drap-timepicker', VueDrapTimepicker);
	},
	VueDrapTimepicker,
};



// WEBPACK FOOTER //
// ./src/index.js